import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Label for deleted message.
 *
 * Muestra "Eliminado" en rojo.
 */
export function SttLabelDeleted(): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Typography variant="caption" style={{ color: 'var(--destructive)' }}>
            {t('general.delete')}
        </Typography>
    );
}
